namespace Areas.Observations {
    "use strict";

    export function goBack() {
        window.history.back();
    }


    export function gotoCreateFromForm() {
        var keyId: any = $('#ObservationsForm').dxForm('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Observations/Create/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoEditFromForm() {
        var keyId: any = $('#ObservationsForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Observations/Edit/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoViewFromForm() {
        var keyId: any = $('#ObservationsForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Observations/View/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoObservationListFromForm() {
        var keyId: any = $('#ObservationsForm').dxForm('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Observations/List/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }


    //export function gotoObservationList() {
    //    var linkInfo = "/Observations/List/Index";
    //    location.href = linkInfo;
    //}

    export function gotoCreate(e) {
        var keyId: any = $('#CreateButton').dxButton('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Observations/Create/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Cannot find default Inspection Project ID. Contact I.S.!", "warning", 2000);
        }
    }

    export function gotoEdit() {
        var dataGrid = $('#ObservationGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Observations/Edit/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoView() {
        var dataGrid = $('#ObservationGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Observations/View/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function viewLink(cellElement, cellInfo) {
        var fieldData = cellInfo.data.observationId;
        var linkInfo = "<a href= '/Observations/View/Index/" + String(fieldData) + "'>View</a>"
        cellElement.html(linkInfo);
    }


    export function status(cellElement, cellInfo) {

        cellElement.html(cellInfo.data.status);

        if (cellInfo.data.status== 'Open') {
            $(cellElement).css('background-color', 'gold');


        }
    }

    export function highLightText() {
        Areas.highLightTextBase("#observationhtmleditor");
    }

}
